import React, { Component } from 'react'
import { connect } from 'react-redux'

import { 
	openModal, 
	openHeaderTab,
	handleTouchMove,
	setUnseenNotifications
} from 'state/actions'

import { CSSTransitionGroup } from 'react-transition-group'
import Icon from 'components/icon/icon'

import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

import ReactDOM from 'react-dom'

import HeaderControls from './header-controls'

import Todos from './header-tabs/todos'
import Notifications from './header-tabs/notifications'
import Messages from './header-tabs/messages'

import HeaderSearch from './header-search'

import { 
	getLastUnreadItem,
	getCurrentUser,
	isCurrentUserAdmin,
	getCurrentAccount
} from 'state/selectors'

import Onboarder from 'components/onboarder/onboarder'

import { isMobile, scaledHeight } from 'utils'

import { createSelector } from 'reselect'

class Header extends Component {
	constructor(props) {
		super(props);

		this.state = {
			searchWidth: null,
			isMenuOpen: false,
			bodyScrollLocked: false,
		}

		this.headertabs = [
			{
				name: 'todos',
				title: 'To-do',
				iconType: 'fa',
				icon: 'fe-check-square',
				component: Todos
			},
			{
				name: 'chats',
				title: 'Chats',
				iconType: 'fa',
				icon: 'fe-mail',
				component: Messages
			},
			{
				name: 'notifications',
				title: 'Notifications',
				iconType: 'fa',
				icon: 'fe-bell',
				component: Notifications
			}
		]

		this.sidesRef = []
		this.headertabRefs = []
		this.targetElement = null
		this.isFlashing = false
	}

	UNSAFE_componentWillUpdate = nextProps => {
		let newState = {}
		let shouldUpdateState = false

		if(isMobile()){
			let tabToEngage = null
			let shouldClearLocks = false

			if((!nextProps.activeHeaderTab && this.state.bodyScrollLocked) || (!this.props.activeChats.length && nextProps.activeChats.length)){
				shouldClearLocks = true
			}

			if(nextProps.activeHeaderTab){
				if(nextProps.activeHeaderTab !== this.props.activeHeaderTab || (this.props.activeChats.length && !nextProps.activeChats.length)){
					tabToEngage = nextProps.activeHeaderTab
				}
			}

			if(tabToEngage){
				newState.bodyScrollLocked = true
				shouldUpdateState = true

				this.targetElement = document.querySelector(`#${tabToEngage}-list`)

				clearAllBodyScrollLocks()
				disableBodyScroll(this.targetElement)
			}else if(shouldClearLocks){
				newState.bodyScrollLocked = false
				shouldUpdateState = true

				clearAllBodyScrollLocks()
			}
		}else{
			const unseenNotifications = nextProps.alertables['notifications']

			if(unseenNotifications !== this.props.unseenNotifications){
				this.props.setUnseenNotifications(unseenNotifications)
			}
		}

		if(shouldUpdateState){
			this.setState(newState)
		}
	}

	toggleMenu = (menuState = null) => {
		if (menuState === null) {
			menuState = !this.state.isMenuOpen
		}

		this.setState({
			isMenuOpen: menuState
		})
	}

	selectHeadertab = (slug, openOnly) => {
		let newSlug = slug

		const {
			activeHeaderTab,
			openHeaderTab
		} = this.props

		if (activeHeaderTab === slug && !openOnly) {
			newSlug = null
		}

		openHeaderTab(newSlug)
	}

	dismissHeadertab = _ => {
		this.props.openHeaderTab(null)
	}

	calculateSearchWidth = _ => {
		let searchWidth = 0;

		this.sidesRef.forEach(ref => {
			searchWidth += ref.getBoundingClientRect().width;
		})

		this.setState({
			searchWidth
		})
	}

	componentDidMount = _ => {
		this.calculateSearchWidth()
	}

	componentWillUnmount(){
		clearAllBodyScrollLocks()
	}

	openDashboard = _ => {
		this.dismissHeadertab()
		this.props.history.push(this.props.match.url + '/dashboard')
	}

	goBack = _ => {
		if (this.props.activeHeaderTab) {
			this.dismissHeadertab()
		} else {
			this.props.history.goBack()
		}
	}

	render() {
		const {
			alertables,
			userData,
			sidebarHidden,
			activeHeaderTab,
			amAdmin,
			openModal,
			currentAccount,
			handleScroll,
			activeChats,
		} = this.props

		if (!userData) {
			return null
		}

		let className = "account-header clear"

		if (sidebarHidden) {
			className += ' sidebar-hidden'
		}

		return (
			<header 
				ref={ref => this.headerRef = ref} 
				className={className}
				id={'account-header'}
			>
				<div className="header-container">
					<div 
						onClick={this.openDashboard} 
						ref={element => this.sidesRef[0] = element} 
						className="header-left logo-section"
					>
						<div>
							<img src={document.base + `/images/logo-${ window.isTkb ? 'tkb-' : '' }white-condensed.png`} />
							<img src={document.base + `/images/logo-${ window.isTkb ? 'tkb-' : '' }white.png`} />
							<img src={document.base + `/images/logo-condensed.png`} />
							<img src={document.base + `/images/logo.png`} />
						</div>
					</div>

					<HeaderSearch 
						width={`calc(100% - ${Math.round(this.state.searchWidth + 5)}px)`} 
						currentAccount={currentAccount} 
					/>
					{isMobile() &&
						<div className="header-mobile-buttons mobile-only">
							<button onClick={_ => { this.goBack() }} className="header-mobile-button">
								<Icon name="angle-left" />
							</button>
							<button onClick={_ => { this.toggleMenu() }} className="header-mobile-button">
								<Icon name="fe-more-vertical" />
							</button>
						</div>
					}
					<div ref={element => this.sidesRef[1] = element} className="header-right">
						{this.headertabs.map((object, i) => {
							const alertCount = alertables[object.name]

							return (
								<button 
									className={activeHeaderTab === object.name ? 'active tooltip-trigger' : 'tooltip-trigger'} 
									onClick={_ => { this.selectHeadertab(object.name) }}
									data-tab={object.name} 
									key={i}
								>
									<i className={activeHeaderTab !== object.name && alertCount > 0 ? 'alert visible' : 'alert'}>
										{alertCount}
									</i>
									{
										object.iconType == 'fa' ?
											<Icon name={object.icon} />
											:
											<img src={object.icon} className="img-icon" />
									}
									<div className="tooltip">
										{object.title}
									</div>
									{ object.name == 'chats' ?
										<Onboarder type='OPEN_CHATS' direction="top-right"/>
									: null }
								</button>
							);
						}, this)}
						<HeaderControls
							toggleMenu={this.toggleMenu}
							isMenuOpen={this.state.isMenuOpen}
							amAdmin={amAdmin}
							openModal={openModal}
							userData={userData}
							currentAccount={currentAccount}
						/>
					</div>
				</div>
				<CSSTransitionGroup
					transitionName="slide-in"
					transitionEnterTimeout={1}
					transitionLeaveTimeout={300}>
					{this.props.activeHeaderTab ?
						<div 
							id="header-tabs" 
							onClick={this.dismissHeadertab} 
							className={'headertabs-container'} 
							style={isMobile() ? {
								height: (scaledHeight() - 80)+'px'
							}: null}
						>
							<div 
								className="headertab" 
								onClick={proxy => proxy.stopPropagation()}
							>
								{this.headertabs.map((object, i) => {
									const Tabcontent = object.component
									let isActive = false

									if (activeHeaderTab === object.name) {
										isActive = true
									}

									const props = {}

									// if you've got a chat open, don't render any of this stuff on mobile.
									if(!isActive || (activeChats.length && isMobile())){
										return null
									}

									return (
										<div 
											id={"headertab-"+object.name} 
											key={i} 
											className={isActive ? 'active' : ''}
										>
											<Tabcontent
												isActive={isActive}
												closeCallback={this.dismissHeadertab}
												object={object}
												currentAccount={currentAccount}
												userData={userData}
												tabName={object.name}
												handleScroll={handleScroll}
												handleTouchMove={handleTouchMove}
												activeHeaderTab={activeHeaderTab}
												{...props}
											/>
										</div>
									);
								}, this)}
							</div>
						</div>
						: null
					}
				</CSSTransitionGroup>
			</header>
		);
	}
}

const getAlertCounts = createSelector(
	[
		state => getCurrentUser(state),
		state => state.account.entities
	],
	(user, entities) => {
		let notificationAlertCount = 0
		let chatAlertCount = 0

		if(user){
			if(user.notifications){
				const alertables = user.notifications.filter(notificationId => {
					const notificationObject = entities.notifications[notificationId]

					return !notificationObject.has_opened
				})

				notificationAlertCount = alertables.length
			}

			if(user.chats){
				user.chats.forEach(chatId => {
					const chatObject = entities.chats[chatId]

					if (chatObject) {
						if (getLastUnreadItem(chatObject, user, entities)) {
							chatAlertCount++
						}
					}
				})
			}
		}

		return {
			notifications: notificationAlertCount,
			chats: chatAlertCount
		}
	}
)

const mapStateToProps = state => {
	return {
		activeChats: state.auth.activeChats,
		userData: getCurrentUser(state),
		amAdmin: isCurrentUserAdmin(state),
		activeHeaderTab: state.account.activeHeaderTab,
		entities: state.account.entities,
		alertables: getAlertCounts(state),
		unseenNotifications: state.account.unseenNotifications
	}
}

export default connect(mapStateToProps, { 
	openModal, 
	openHeaderTab,
	setUnseenNotifications
})(Header)